import React from 'react';
import { Badge } from '@/components/ui/badge';
import { useTranslation } from '@/contexts/I18nContext';
import { ExternalLink } from 'lucide-react';

interface SocialProvider {
  name: string;
  icon: React.ReactNode;
  color: string;
}

interface SocialLoginInfoProps {
  provider: SocialProvider;
}

export const SocialLoginInfo: React.FC<SocialLoginInfoProps> = ({ provider }) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-3">
      <h3 className="font-medium">{t('security.loginMethod')}</h3>
      
      <div className="flex items-center justify-between p-4 border rounded-lg">
        <div className="flex items-center gap-3">
          <div 
            className="p-2 rounded-full"
            style={{ backgroundColor: `${provider.color}15`, color: provider.color }}
          >
            {provider.icon}
          </div>
          <div>
            <div className="flex items-center gap-2">
              <span className="font-medium">{provider.name}</span>
              <Badge variant="secondary" className="text-xs">
                {t('security.socialLogin')}
              </Badge>
            </div>
            <p className="text-sm text-muted-foreground">
              {t('security.socialLoginConnected').replace('{provider}', provider.name)}
            </p>
          </div>
        </div>
        
        <ExternalLink className="h-4 w-4 text-muted-foreground" />
      </div>
      
      <div className="p-3 bg-blue-50 border border-blue-200 rounded-lg">
        <p className="text-sm text-blue-800">
          <span className="font-medium">{t('security.socialLoginNote')}: </span>
          {t('security.socialLoginNoteDesc').replace(/{provider}/g, provider.name)}
        </p>
      </div>
    </div>
  );
};
